<ul class="layout-menu">
  @for (category of model; track category) {
    @if (category.visible) {
      <div class="layout-menuitem-main-text">{{ category.label }}</div>
      @for (item of category.items; track item; let i = $index) {
        @if (!item.separator) {
          <app-menuitem
            [item]="item"
            [index]="i"
            [root]="true"
          />
        } @else {
          <li class="menu-separator"></li>
        }
      }
    }
  }
</ul>
